import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetInfoDeclaracionJuradaViolenciaGenero = {
  status: number | null;
  statusText: string | null;
};

const useGetInfoDeclaracionJuradaViolenciaGenero = () => {
  const [loadingGetInfoDeclaracionJuradaViolenciaGenero, setLoadingGetInfoDeclaracionJuradaViolenciaGenero] = useState(false);
  const [successGetInfoDeclaracionJuradaViolenciaGenero, setSuccessGetInfoDeclaracionJuradaViolenciaGenero] = useState(false);
  const [errorGetInfoDeclaracionJuradaViolenciaGenero, setErrorGetInfoDeclaracionJuradaViolenciaGenero] = useState<any>(null);
  const [dataGetInfoDeclaracionJuradaViolenciaGenero, setDataGetInfoDeclaracionJuradaViolenciaGenero] = useState<any>(null);

  const [statusGetInfoDeclaracionJuradaViolenciaGenero, setStatusGetInfoDeclaracionJuradaViolenciaGenero] =
    useState<StatusGetInfoDeclaracionJuradaViolenciaGenero>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  const getInfoDeclaracionJuradaViolenciaGenero = async (
    userId: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetInfoDeclaracionJuradaViolenciaGenero(true);
    setSuccessGetInfoDeclaracionJuradaViolenciaGenero(false);
    setErrorGetInfoDeclaracionJuradaViolenciaGenero(null);

    try {
      const res = await apiRecord.getInfoSolicitudDeclaracionJuradaFuerzaMayor(userId);

      setStatusGetInfoDeclaracionJuradaViolenciaGenero({
        status: res.status,
        statusText: res.statusText
      });

      setSuccessGetInfoDeclaracionJuradaViolenciaGenero(true);
      setDataGetInfoDeclaracionJuradaViolenciaGenero(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {

      setStatusGetInfoDeclaracionJuradaViolenciaGenero({
        status: err?.response?.status || 500,
        statusText: err?.response?.statusText || "Error"
      });

      setErrorGetInfoDeclaracionJuradaViolenciaGenero(err);
      console.error("Error en getInfoDeclaracionJuradaViolenciaGenero:", err);

      throw err;

    } finally {
      setLoadingGetInfoDeclaracionJuradaViolenciaGenero(false);
    }
  };

  return {
    getInfoDeclaracionJuradaViolenciaGenero,
    loadingGetInfoDeclaracionJuradaViolenciaGenero,
    successGetInfoDeclaracionJuradaViolenciaGenero,
    errorGetInfoDeclaracionJuradaViolenciaGenero,
    dataGetInfoDeclaracionJuradaViolenciaGenero,
    statusGetInfoDeclaracionJuradaViolenciaGenero
  };
};

export default useGetInfoDeclaracionJuradaViolenciaGenero;
